module.exports = "<app-core></app-core>\n"